import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=8a6497be&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"
import style0 from "./Company.vue?vue&type=style&index=0&id=8a6497be&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6497be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a6497be')) {
      api.createRecord('8a6497be', component.options)
    } else {
      api.reload('8a6497be', component.options)
    }
    module.hot.accept("./Company.vue?vue&type=template&id=8a6497be&scoped=true", function () {
      api.rerender('8a6497be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/Company.vue"
export default component.exports